import { post } from './ApiHelper'
import config from '../config'

const { baseUrl } = config

// 登录
export const memUserLogin = ({ username = '', password = '' }) => {
  let url = baseUrl + '/memUserLogin'
  const formData = new FormData()
  formData.append('username', username)
  formData.append('password', password)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 注册
export const memUserRegist = ({
  username = '',
  password = '',
  email = '',
  companyname = '',
  contactpersonphone = ''
}) => {
  let url = baseUrl + '/memUserRegist'
  const formData = new FormData()
  formData.append('username', username)
  formData.append('password', password)
  formData.append('email', email)
  formData.append('companyname', companyname)
  formData.append('contactpersonphone', contactpersonphone)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 缴费页面提交
export const addPayment = ({ file, membershipid = '', year = '', amount = '', paydate = '' }) => {
  let url = baseUrl + '/addPayment'
  const formData = new FormData()
  formData.append('file', file)
  formData.append('membershipid', membershipid)
  formData.append('year', year)
  formData.append('amount', amount)
  formData.append('paydate', paydate)
  let params = {
    body: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  }
  return post(url, params)
}

// 查询缴费凭证（分页）
export const getPayment = ({ currentPage = '', pageSize = '', membershipid = '', state }) => {
  let url = baseUrl + '/getPayment'
  const formData = new FormData()
  formData.append('currentPage', currentPage)
  formData.append('pageSize', pageSize)
  formData.append('membershipid', membershipid)
  formData.append('state', state)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 查询报名人员列表
export const getEventSignUp = ({ currentPage = '', pageSize = '', membershipid = '', eventid = '' }) => {
  let url = baseUrl + '/getEventSignUp'
  const formData = new FormData()
  formData.append('currentPage', currentPage)
  formData.append('pageSize', pageSize)
  formData.append('membershipid', membershipid)
  formData.append('eventid', eventid)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 查询会议列表（分页）
export const getEventForMem = ({ currentPage = '', pageSize = '', membershipid = '' }) => {
  let url = baseUrl + '/getEventForMem'
  const formData = new FormData()
  formData.append('currentPage', currentPage)
  formData.append('pageSize', pageSize)
  formData.append('membershipid', membershipid)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 诉求查询（分页）
export const getFeedBackPage = ({ currentPage = '', pageSize = '', membershipid = '' }) => {
  let url = baseUrl + '/getFeedBackPage'
  const formData = new FormData()
  formData.append('currentPage', currentPage)
  formData.append('pageSize', pageSize)
  formData.append('membershipid', membershipid)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 会员诉求添加
export const addFeedBack = ({ membershipid = '', name = '', phone = '', position = '', title = '', content = '' }) => {
  let url = baseUrl + '/addFeedBack'
  const formData = new FormData()
  formData.append('membershipid', membershipid)
  formData.append('name', name)
  formData.append('phone', phone)
  formData.append('position', position)
  formData.append('title', title)
  formData.append('content', content)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 消息查询
export const getMsgForMem = ({ currentPage = '', pageSize = '', membershipid = '' }) => {
  let url = baseUrl + '/getMsgForMem'
  const formData = new FormData()
  formData.append('currentPage', currentPage)
  formData.append('pageSize', pageSize)
  formData.append('membershipid', membershipid)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 修改密码
export const resetPwd = ({ username = '', password = '', newPassword = '' }) => {
  let url = baseUrl + '/resetPwd'
  const formData = new FormData()
  formData.append('username', username)
  formData.append('password', password)
  formData.append('newPassword', newPassword)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 忘记密码
export const forgetPwd = ({
  username = '',
  contactpersonphone = '',
  password = '',
  file = ''
}) => {
  let url = baseUrl + '/forgetPwd'
  const formData = new FormData()
  formData.append('username', username)
  formData.append('contactpersonphone', contactpersonphone)
  formData.append('password', password)
  formData.append('file', file)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 查询会员申请信息（个人）
export const findOneInfo = ({ userid = '' }) => {
  let url = baseUrl + '/MemberInfo/findOneInfo'
  const formData = new FormData()
  formData.append('userid', userid)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 添加会员申请信息（暂存） 
export const temporaryStorage = ({ 
  // 基本信息
  companyname = '', // 单位名称（中文）
  companyname1 = '', // 单位名称（英文）
  address = '', // 联系地址
  administrativeregion = '', // 所在行政区
  website = '', // 公司网址
  postcode = '', // 邮编
  recommendcompany = '', // 推荐单位
  introduction = '', // 单位简介
  fileid = '', // 单位简介附件
  // 企业类型
  ownershipoption = '', // 企业类型
  ownershipother = '', // 企业类型备注
  // 企业规模
  scaleoption = '', // 企业规模
   // 上市公司
  public_company = '', // 上市公司
  // 主营业务
  businessnatureoption = [], // 主营业务
  businessnatureother = '', // 主营业务备注
  // 会员代表
  representativename = '', // 姓名（中文）
  representativename1 = '', // 姓名（英文）
  gender = '', // 性别
  representativeposition = '', // 职务
  representativetel = '', // 电话
  representativephone = '', // 手机
  representativeemail = '', // 电邮
  representativetax = '', // 传真
  idcard = '', // 身份证号
  politicsstatus = '', // 政治面貌
  ismembership = '', // 是否离退
  // 联系人
  contactpersoncontactname = '', // 姓名(中文)
  contactpersoncontactname1 = '', // 姓名(英文)
  contactpersonposition = '', // 职务
  contactpersonemail = '', // 电邮
  contactpersonphone = '', // 手机
  contactpersontel = '', // 电话
  contactpersonfax = '', // 传真
  contactpersonaddress = '', // 联系地址
  contactpersonpostcode = '', // 邮编
  // 党建工作
  partyoption = '', // 党建工作
  partyremark = '', // 党建工作备注
  partyestablishtime = '', // 成立时间
  partymembernumber = '', // 党员人数
  partylinkman = '', // 党建联系人
  partyposition = '', // 党建职务
  partyphone = '', // 党建手机
  partytel = '', // 党建电话
  partyemail = '', // 党建邮箱
  partyother = '', // 党建其他情况说明
  // 用户信息类
  userid = '' // 登录人id
}) => {
  let url = baseUrl + '/MemberInfo/temporaryStorage'
  const formData = new FormData()
  // 基本信息
  formData.append('companyname', companyname)
  formData.append('companyname1', companyname1)
  formData.append('address', address)
  formData.append('administrativeregion', administrativeregion)
  formData.append('website', website)
  formData.append('postcode', postcode)
  formData.append('recommendcompany', recommendcompany)
  formData.append('introduction', introduction)
  formData.append('fileid', fileid)
  // 企业类型
  formData.append('ownershipoption', ownershipoption)
  formData.append('ownershipother', ownershipother)
  // 企业规模
  formData.append('scaleoption', scaleoption)
  // 上市公司
  formData.append('public_company', public_company)
  // 主营业务
  formData.append('businessnatureoption', businessnatureoption) 
  formData.append('businessnatureother', businessnatureother)
  // 会员代表
  formData.append('representativename', representativename)
  formData.append('representativename1', representativename1)
  formData.append('gender', gender)
  formData.append('representativeposition', representativeposition)
  formData.append('representativetel', representativetel)
  formData.append('representativephone', representativephone)
  formData.append('representativeemail', representativeemail)
  formData.append('representativetax', representativetax)
  formData.append('idcard', idcard)
  formData.append('politicsstatus', politicsstatus)
  formData.append('ismembership', ismembership)
  // 联系人
  formData.append('contactpersoncontactname', contactpersoncontactname)
  formData.append('contactpersoncontactname1', contactpersoncontactname1)
  formData.append('contactpersonposition', contactpersonposition)
  formData.append('contactpersonemail', contactpersonemail)
  formData.append('contactpersonphone', contactpersonphone)
  formData.append('contactpersontel', contactpersontel)
  formData.append('contactpersonfax', contactpersonfax)
  formData.append('contactpersonaddress', contactpersonaddress)
  formData.append('contactpersonpostcode', contactpersonpostcode)
  // 党建工作
  formData.append('partyoption', partyoption)
  formData.append('partyremark', partyremark)
  formData.append('partyestablishtime', partyestablishtime)
  formData.append('partymembernumber', partymembernumber)
  formData.append('partylinkman', partylinkman)
  formData.append('partyposition', partyposition)
  formData.append('partyphone', partyphone)
  formData.append('partytel', partytel)
  formData.append('partyemail', partyemail)
  formData.append('partyother', partyother)
  // 用户信息类
  formData.append('userid', userid)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 添加会员申请信息
export const create = ({
  // 基本信息
  companyname = '', // 单位名称（中文）
  companyname1 = '', // 单位名称（英文）
  address = '', // 联系地址
  administrativeregion = '', // 所在行政区
  website = '', // 公司网址
  postcode = '', // 邮编
  recommendcompany = '', // 推荐单位
  introduction = '', // 单位简介
  fileid = '', // 单位简介附件
  // 企业类型
  ownershipoption = '', // 企业类型
  ownershipother = '', // 企业类型备注
  // 企业规模
  scaleoption = '', // 企业规模
    // 上市公司
  public_company = '', // 上市公司
  // 主营业务
  businessnatureoption = [], // 主营业务
  businessnatureother = '', // 主营业务备注
  // 会员代表
  representativename = '', // 姓名（中文）
  representativename1 = '', // 姓名（英文）
  gender = '', // 性别
  representativeposition = '', // 职务
  representativetel = '', // 电话
  representativephone = '', // 手机
  representativeemail = '', // 电邮
  representativetax = '', // 传真
  idcard = '', // 身份证号
  politicsstatus = '', // 政治面貌
  ismembership = '', // 是否离退
  // 联系人
  contactpersoncontactname = '', // 姓名(中文)
  contactpersoncontactname1 = '', // 姓名(英文)
  contactpersonposition = '', // 职务
  contactpersonemail = '', // 电邮
  contactpersonphone = '', // 手机
  contactpersontel = '', // 电话
  contactpersonfax = '', // 传真
  contactpersonaddress = '', // 联系地址
  contactpersonpostcode = '', // 邮编
  // 党建工作
  partyoption = '', // 党建工作
  partyremark = '', // 党建工作备注
  partyestablishtime = '', // 成立时间
  partymembernumber = '', // 党员人数
  partylinkman = '', // 党建联系人
  partyposition = '', // 党建职务
  partyphone = '', // 党建手机
  partytel = '', // 党建电话
  partyemail = '', // 党建邮箱
  partyother = '', // 党建其他情况说明
  // 用户信息类
  userid = '' // 登录人id
}) => {
  let url = baseUrl + '/MemberInfo/create'
  const formData = new FormData()
  // 基本信息
  formData.append('companyname', companyname)
  formData.append('companyname1', companyname1)
  formData.append('address', address)
  formData.append('administrativeregion', administrativeregion)
  formData.append('website', website)
  formData.append('postcode', postcode)
  formData.append('recommendcompany', recommendcompany)
  formData.append('introduction', introduction)
  formData.append('fileid', fileid)
  // 企业类型
  formData.append('ownershipoption', ownershipoption)
  formData.append('ownershipother', ownershipother)
  // 企业规模
  formData.append('scaleoption', scaleoption)
  // 上市公司
  formData.append('public_company', public_company)
  // 主营业务
  formData.append('businessnatureoption', businessnatureoption)
  formData.append('businessnatureother', businessnatureother)
  // 会员代表
  formData.append('representativename', representativename)
  formData.append('representativename1', representativename1)
  formData.append('gender', gender)
  formData.append('representativeposition', representativeposition)
  formData.append('representativetel', representativetel)
  formData.append('representativephone', representativephone)
  formData.append('representativeemail', representativeemail)
  formData.append('representativetax', representativetax)
  formData.append('idcard', idcard)
  formData.append('politicsstatus', politicsstatus)
  formData.append('ismembership', ismembership)
  // 联系人
  formData.append('contactpersoncontactname', contactpersoncontactname)
  formData.append('contactpersoncontactname1', contactpersoncontactname1)
  formData.append('contactpersonposition', contactpersonposition)
  formData.append('contactpersonemail', contactpersonemail)
  formData.append('contactpersonphone', contactpersonphone)
  formData.append('contactpersontel', contactpersontel)
  formData.append('contactpersonfax', contactpersonfax)
  formData.append('contactpersonaddress', contactpersonaddress)
  formData.append('contactpersonpostcode', contactpersonpostcode)
  // 党建工作
  formData.append('partyoption', partyoption)
  formData.append('partyremark', partyremark)
  formData.append('partyestablishtime', partyestablishtime)
  formData.append('partymembernumber', partymembernumber)
  formData.append('partylinkman', partylinkman)
  formData.append('partyposition', partyposition)
  formData.append('partyphone', partyphone)
  formData.append('partytel', partytel)
  formData.append('partyemail', partyemail)
  formData.append('partyother', partyother)
  // 用户信息类
  formData.append('userid', userid)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 查询新闻列表
export const getNewsList = ({ category = '' }) => {
  let url = baseUrl + '/getNewsList'
  const formData = new FormData()
  formData.append('category', category)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 查询缴费凭证
export const getJFTZ = () => {
  let url = baseUrl + '/getJFTZ'
  const formData = new FormData()
  let params = {
    body: formData
  }
  return post(url, params)
}
 
// 查询专委会信息（通过id）
export const findByCommitteeid = ({ id = '' }) => {
  let url = baseUrl + '/Committee/findByCommitteeid'
  const formData = new FormData()
  formData.append('id', id)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 下载会员申请表（word）
export const downloadWord = ({ userid = '' }) => {
  let url = baseUrl + '/MemberInfo/downloadWord'
  const formData = new FormData()
  formData.append('userid', userid)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 会议添加报名人员
export const addEventSignUp = ({ eventid = '', membershipid = '', company = '', job = '', name = '', phone = '' }) => {
  let url = baseUrl + '/addEventSignUp'
  const formData = new FormData()
  formData.append('eventid', eventid)
  formData.append('membershipid', membershipid)
  formData.append('company', company)
  formData.append('job', job)
  formData.append('name', name)
  formData.append('phone', phone)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 会议修改报名状态（提交）
export const updateEventAudit = ({ eventid = '', membershipid = '', state = '' }) => {
  let url = baseUrl + '/updateEventAudit'
  const formData = new FormData()
  formData.append('eventid', eventid)
  formData.append('membershipid', membershipid)
  formData.append('state', state)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 删除会议报名人员
export const delEventSignUp = ({ id = '' }) => {
  let url = baseUrl + '/delEventSignUp'
  const formData = new FormData()
  formData.append('id', id)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 根据姓名查询会议报名人员
export const getEventSignUpByName = ({ name = '', membershipid = '' }) => {
  let url = baseUrl + '/getEventSignUpByName'
  const formData = new FormData()
  formData.append('name', name)
  formData.append('membershipid', membershipid)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 查看会议报名状态
export const getSignUpState = ({ eventid = '', membershipid = '' }) => {
  let url = baseUrl + '/getSignUpState'
  const formData = new FormData()
  formData.append('eventid', eventid)
  formData.append('membershipid', membershipid)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 查看常用联系人列表
export const getLinkMenForEvent = ({ pageSize = '', currentPage = '', membershipid = '' }) => {
  let url = baseUrl + '/getLinkMenForEvent'
  const formData = new FormData()
  formData.append('pageSize', pageSize)
  formData.append('currentPage', currentPage)
  formData.append('membershipid', membershipid)
  let params = {
    body: formData
  }
  return post(url, params)
}

// 查询弹窗消息
export const getNoticeMsg = ({userid = '' }) => {
  let url = baseUrl + '/getNoticeMsg'
  const formData = new FormData()
  formData.append('userid', userid)
  let params = {
    body: formData
  }
  return post(url, params)
}
